import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgPmEbtBlackWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.889 6.75H32.11c.65 0 1.139.506 1.139 1.083V20c0 2.35-.702 4.141-1.905 5.345C30.14 26.548 28.35 27.25 26 27.25H1.889c-.65 0-1.139-.506-1.139-1.083V7.833c0-.577.489-1.083 1.139-1.083Z",
  fill: "#fff",
  stroke: "#08031D",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.482 20.667c.654 0 1.185-.597 1.185-1.334 0-.736-.531-1.333-1.185-1.333H10v2.667m1.482 0H10m1.482 0c.654 0 1.185.597 1.185 1.333s-.531 1.333-1.185 1.333H10v-2.666M7.5 18H5v2.667m2.5 2.666H5v-2.666m0 0h2M14.722 18H16.5m0 0h1.778M16.5 18v5.333M22 11h6m-23 .5V13a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1Z",
  stroke: "#08031D",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export { SvgPmEbtBlackWhite as default };
